import { AppRouter } from "./Router/Router";

function App() {
  return <AppRouter />;
}

export default App;
